import * as React from 'react';
import { Alert } from "@mui/material";

export const Info = () => {
    return <Alert severity='info'>{"There appear to be no workshops in this category."}</Alert>
}